module.exports = __webpack_public_path__ + "static/media/Duskull_gaussian2.17393484.png";